import { Image, InputProps, Spin } from '@arco-design/web-react';
import React from 'react';
import { useCaptcha } from './api';

export function Captcha({ onChange }: InputProps) {
  const { data, refetch, isFetching, isLoading, isError } = useCaptcha({
    config: {
      onSuccess: (res) => {
        if (onChange) {
          onChange(res.data.key, null);
        }
      },
      refetchOnWindowFocus: false,
      onError: () => {
        // Message.error(err.message);
      },
    },
  });

  if (isLoading || isFetching) {
    return <Spin loading delay={300} style={{ width: '100%', textAlign: 'center' }} />;
  }

  if (isError) {
    return null;
  }

  return (
    <Image
      onClick={() => refetch()}
      width={96}
      preview={false}
      height={32}
      src={data.data.captcha}
      alt="capture"
      style={{ cursor: 'pointer' }}
    />
  );
}
